















import Vue from "vue";

interface Props {
  opened: boolean;
}

/**
 * @emits modal-bg-click
 */
export default Vue.extend<Props>({
  name: "JzModal",
  functional: true,

  props: { opened: { type: Boolean, default: false } }
});
